module.exports = "<div class=\"add-container\" ng-click=\"ctrl.addWidget()\">\n    <i class=\"icon-plus\"></i>\n</div>";